import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';

interface PrivateRouteProps {
  children: ReactNode;
}

const normalizeBasePath = (value?: string | null): string => {
  if (!value || value === '/' || value === './') {
    return '';
  }
  const trimmed = value.replace(/^\/+|\/+$/g, '');
  return trimmed ? `/${trimmed}` : '';
};

const BASE_PATH = normalizeBasePath(import.meta.env.BASE_URL as string | undefined);
const LOGIN_ROUTE = `${BASE_PATH}/login`.replace('//', '/');
const AUTH_PREFIX = `${BASE_PATH}/auth/`.replace('//', '/');

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useSelector((state: RootState) => (state as any).auth);
  const roles = useSelector((state: RootState) => (state as any).auth.user?.roles || []);
  const hasAccessRole = Array.isArray(roles) ? roles.includes('access_travel') : true;
  const location = useLocation();
  const isCallbackRoute = location.pathname.startsWith(AUTH_PREFIX);
  const isLoginRoute = location.pathname === LOGIN_ROUTE;

  if (!isAuthenticated && !isCallbackRoute && !isLoginRoute) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    // Redirect to login page, preserving intended return URL
    return <Navigate to={`${LOGIN_ROUTE}?returnUrl=${returnUrl}`} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
